<template>
    <div>
        <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
        <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


        <div v-show="!showView">
            <div class="form-edit-page row row-space">
                <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentYear'" v-model="dateRange"/></div>

                <div v-if="globalStore.ckperfilsupervisor" class="form-item">
                    <SimSelect :ckAddTodos="true" v-model:idSelecionado="idSim" />
                </div>

                <div class="form-item">
                    <template v-if="!globalStore.showSelectEstabelecimento">
                        <label class="label-caption">Estabelecimento</label>
                        <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                    </template> <template v-else>
                        <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
                    </template>
                </div>
                
                <button type="button" class="buttom-icon--search" @click="lerDados" />
                <button type="button" class="buttom-icon--close" @click="closeForm" />
            </div>


            <div v-if="lsDados.length>0" class="table-wrapper"><table>
                <thead>
                    <tr>
                        <th>Protocolo</th>
                        <th>Vistoria</th>
                        <th>Registro</th>
                        <th>Estabelecimento</th>
                        <th>Situação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in lsDados" :key="item.id" @click="onClickItem(item)" 
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char20">{{ item.protocolo }}</td>
                        <td class="col-width-char10 center">{{ formatDateFromJson(item.dhencerramento) }}</td>
                        <td class="col-width-char10 center">{{ formatDateFromJson(item.dhprotocolo) }}</td>
                        <td>{{ item.nmestabelecimento }}</td>
                        <td class="col-width-char40">{{ item.nmstatus }}</td>
                    </tr>
                </tbody>
            </table></div>


            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>
        </div>
    </div>


    <div v-if="showView">
        <RacViewPage :idView="idView" @close="showView = false" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { formatDateFromJson, validarIntervaloDatas } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import RacViewPage from '../visualizacoes/RacViewPage.vue';
import SimSelect from '@/components/selects/SimSelect.vue';

const emit = defineEmits(['close']);
const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const estabelecimentoSelecionado = ref(null);
const idSim = ref(null);
const idView = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const msgAlerta = ref(null);
const showView = ref(false);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}


const lerDados = async() => {
    try {
        const x = validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        if (x) throw new Error(x);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.ckperfilsupervisor ? idSim.value : globalStore.idsim,
            idestabelecimento: (globalStore.showSelectEstabelecimento) ? estabelecimentoSelecionado.value : globalStore.idestabelecimento,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const req = await Api.genericPost('/dados/rac', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.response?.data || error.message}`;
    } finally {isLoading.value = false;}
}


function onClickItem(item){
    idView.value = item.id;
    showView.value = true;

}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>